module.exports = __webpack_public_path__ + "static/img/09.5dbfd32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/09.jpg
// module id = 2JKp
// module chunks = 1